import React, { useContext, useMemo } from 'react';
import { LogViewer } from '../log-viewer';
import { type LogItemProps } from '../log-viewer/log-item';
import { type FlowLogEvent } from '../../../types/flow-log';
import { formatTime } from '../../../utils/format';
import { getFlowLogIcon } from './get-log-icon';
import { getParametersForModuleType, getSubtitleForModuleType } from './parameter-selector';
import { LogType } from '../../../types/visualizer';
import { AuthContext } from '@@/contexts/AuthContext';
import { useConfigurationContext } from '../../../contexts/configuration-context';

export function FlowLogViewer(props: { contactFlowLogs: FlowLogEvent[] }) {
  const { instanceData } = useContext(AuthContext);
  const configuration = useConfigurationContext();

  const logItems = useMemo(() => {
    if (!instanceData) return [];

    const items: LogItemProps[] = props.contactFlowLogs.map((event, index) => {
      let grouped = false;

      if (index > 0 && event.Identifier && props.contactFlowLogs) {
        let consecutiveCount = 0;
        for (let i = index - 1; i >= 0; i--) {
          if (props.contactFlowLogs[i].Identifier === event.Identifier) {
            consecutiveCount++;
          } else {
            break;
          }
        }
        grouped = consecutiveCount > 0;
      }

      return {
        timestamp: formatTime(event.Timestamp),
        title: event.ContactFlowModuleType,
        subtitle: getSubtitleForModuleType(event) || JSON.stringify(event, null, 2),
        parameters: getParametersForModuleType(event),
        identifier: event.Identifier,
        result: event.Results,
        icon: getFlowLogIcon(event.ContactFlowModuleType, event),
        indentLevel: 0,
        grouped: grouped,
        raw: event,
        index: index,
        accountId: instanceData.awsAccountId,
        instanceAlias: configuration.connect.instanceAlias
      };
    });

    return items;
  }, [props.contactFlowLogs, instanceData]);

  if (props.contactFlowLogs.length === 0) {
    return <div className='flex items-center justify-center h-full text-neutral-500'>No flow logs available</div>;
  }

  return <LogViewer logs={logItems} logType={LogType.FLOW_LOG} emptyMessage='No Flow Logs available' />;
}
